import React, { useState } from "react";
import axios from "axios";

export default function TodayWork() {
  // 🔹 250 ads state
  const [ads, setAds] = useState(
    Array.from({ length: 250 }, (_, i) => ({
      id: i + 1,
      link: "",
    }))
  );

  const [loading, setLoading] = useState(false);

  // 🔹 Handle input change
  const handleChange = (index, value) => {
    const updated = [...ads];
    updated[index].link = value;
    setAds(updated);
  };

  // 🔹 Publish all ads
  const handlePublish = async () => {
    const filteredAds = ads.filter((a) => a.link.trim() !== "");

    if (filteredAds.length === 0) {
      alert("⚠️ Please add at least one Ad link");
      return;
    }

    try {
      setLoading(true);

      // 🔴 API (change later if needed)
      await axios.post("https://api.earnmoney0.top/api/admin/today-work", {
        ads: filteredAds,
      });

      alert("✅ Ads Published Successfully!");
    } catch (err) {
      console.error(err);
      alert("❌ Failed to publish ads");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <h1 style={styles.title}>📢 Set Your Ads List</h1>

        <button
          onClick={handlePublish}
          disabled={loading}
          style={{
            ...styles.publishBtn,
            opacity: loading ? 0.6 : 1,
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Publishing..." : "🚀 Publish"}
        </button>
      </div>

      {/* ADS LIST */}
      <div style={styles.listWrapper}>
        {ads.map((ad, index) => (
          <div key={ad.id} style={styles.row}>
            <div style={styles.adLabel}>Ads - {ad.id}</div>

            <input
              type="text"
              placeholder="Paste ads link here..."
              value={ad.link}
              onChange={(e) => handleChange(index, e.target.value)}
              style={styles.input}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

/* ===================== CSS ===================== */

const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#0b0f1a",
    color: "#ffffff",
    padding: "20px",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    flexWrap: "wrap",
    gap: "15px",
  },

  title: {
    fontSize: "26px",
    fontWeight: "700",
  },

  publishBtn: {
    background: "linear-gradient(90deg, #22c55e, #16a34a)",
    border: "none",
    padding: "10px 22px",
    borderRadius: "8px",
    fontWeight: "700",
    color: "#000",
  },

  listWrapper: {
    background: "#020617",
    borderRadius: "12px",
    padding: "16px",
    maxHeight: "calc(100vh - 120px)",
    overflowY: "auto",
  },

  row: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "10px",
  },

  adLabel: {
    width: "80px",
    fontWeight: "600",
    color: "#facc15",
    flexShrink: 0,
  },

  input: {
    flex: 1,
    background: "#111827",
    border: "1px solid #374151",
    borderRadius: "6px",
    padding: "8px 10px",
    color: "#fff",
    outline: "none",
  },
};